<template>
  <div>
    <img src="../assets/my/2025.png" style="height:120px;"/>
    	<div id="wrapper">
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Program
    				</strong>
    			</p>
    			<p>

              <p>Click  <a href="Workshops_Program-IDASB2025-15Dec-1208.pdf">here</a> to download the program(pdf file)</p>
              <!-- <p>Will be updated soon</p> -->




    		</div>
    	</div>
      <footer-component></footer-component>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
